import {
  QUOTE_CALCULATED,
  QUOTES_FETCH_REQUESTED,
  QUOTES_FETCHED,
  QUOTES_FETCH_FAILED
} from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';
import { toggleSpinner } from './commonActions';

export const calculateQuote = (params) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.calculateQuote(params)
    .then(quote => dispatch({
      type: QUOTE_CALCULATED,
      data: { quote }
    }));
};

export const bindQuote = (orgId, quoteUuid, applicationNumber=null, callback=null) => (dispatch, getState) => {
  const { api } = getState().app;

  dispatch(toggleSpinner());

  return api.bindQuote(orgId, quoteUuid, applicationNumber)
    .then(() => {
      dispatch(fetchQuotes(orgId));
      if (callback) {
        callback();
      }
    });
};

export const fetchQuotes = (orgId) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.fetchQuotes(orgId),
    data: { orgId },
    pending: QUOTES_FETCH_REQUESTED,
    success: QUOTES_FETCHED,
    failure: QUOTES_FETCH_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/quotes.js